import * as momentRoutines from './momentRoutines';
import produce from 'immer';

const momentsReducer = (
    state = {
        all: {},
        config: {},
    },
    action,
) => {
    switch (action.type) {
        case momentRoutines.clearMomentsData.TRIGGER:
            return {
                ...state,
                all: {},
            };
        case momentRoutines.syncMoments.SUCCESS:
            return produce(state, draft => {
                draft.all = action.payload;
            });
        case momentRoutines.syncMomentsConfig.SUCCESS:
            return produce(state, draft => {
                draft.config = action.payload;
            });

        default:
            return state;
    }
};
export default momentsReducer;
